export default {"src":"/_next/static/media/credlixLogoIcon.42d44336.svg","height":28,"width":100};